<div>
    <mat-expansion-panel #panel [expanded]="isExpanded">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Pesquisa
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="form" class="mt-4 mx-auto">
            <div class="flex flex-col justify-center items-start">

            </div>

            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline">
                    <mat-label>Cliente</mat-label>
                    <input matInput formControlName="cliente" readonly />
                    @if (this.form.get('cliente')!.enabled) {
                    <button mat-icon-button matSuffix (click)="addClient()">
                        <mat-icon>add</mat-icon>
                    </button>
                    }
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Consultor Operacional</mat-label>

                    <input matInput formControlName="consultant" readonly />
                    @if (this.form.get('consultant')!.enabled) {
                    <button mat-icon-button matSuffix (click)="addConsultanOperational()">
                        <mat-icon>add</mat-icon>
                    </button>
                    }

                </mat-form-field>


            </div>

            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Código TG</mat-label>
                    <input matInput formControlName="codeTg" />
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Evento Nome</mat-label>

                    <input matInput formControlName="event" />

                </mat-form-field>

            </div>
            <div class="flex flex-row justify-start gap-3 items-center w-full">
                <div class="flex justify-between gap-4 items-center ">

                    <mat-form-field class="input-tg w-6/12 ml-2" appearance="outline" hideRequiredMarker>
                        <mat-label>Data Inicio</mat-label>
                        <input matInput [matDatepicker]="dateInitial" formControlName="dateInitial" />
                        <mat-datepicker-toggle matSuffix [for]="dateInitial"></mat-datepicker-toggle>
                        <mat-datepicker #dateInitial></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="input-tg w-6/12" appearance="outline" hideRequiredMarker>
                        <mat-label>Data Fim</mat-label>
                        <input matInput [matDatepicker]="dateEnd" formControlName="dateEnd" />
                        <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                        <mat-datepicker #dateEnd></mat-datepicker>
                    </mat-form-field>

                </div>

                <mat-form-field class="input-tg w-4/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                        <mat-option MatDatepicker *ngFor="let status of listStatus" [value]="status.id">
                            {{ status.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>


            </div>


        </div>
        <div class="mb-3 flex justify-end items-center gap-2">
            <button class="btn-icon" (click)="resetForm()"
                [matTooltip]="'Limpar Pesquisar'"><mat-icon>replay</mat-icon></button>
            <button class="btn-icon" (click)="searchFleet()"
                [matTooltip]="'Pesquisa'"><mat-icon>search</mat-icon></button>
        </div>





    </mat-expansion-panel>

</div>